// This is an auto-generated file. Do not edit it directly — your changes will be overwritten the next time the model configs are generated.

 import type { Tenant } from '@pigello/pigello-matrix';


import { useGetInstance, useGetList } from '@/requests/hooks';

import type {
  useGetGenericInstanceProps,
  useGetGenericListProps,
} from '@/requests/types';


export const useGetTenant = (
  options: useGetGenericInstanceProps<Tenant>
) => {
  return useGetInstance<Tenant>({
    ...options,
    modelName: 'tenant'
  });
};

export const useGetTenantList = (
  options: useGetGenericListProps<Tenant>
) => {
  return useGetList<Tenant>({
    ...options,
    modelName: 'tenant'
  });
};
